export default {
  data () {
    return {
      tableRef: 'table',
      addOrUpdateVisible: false
    }
  },
  activated () {
    if(this.$refs[this.tableRef]&&this.$refs[this.tableRef].autoLoad){
      console.log('load')
      this.reload()
    }
  },
  methods: {
    clear(){
      this.$refs[this.tableRef].dataList=[]
    },
    resize(){
      this.$refs[this.tableRef].resize()
    },
    exportExcel(fileName){
      this.$refs[this.tableRef].export(fileName)
    },
    doBatchDelete(){
      this.$refs[this.tableRef].doBatchDelete()
    },
    getDataList () {
      this.$nextTick(() => {
        this.clearSelection()
        this.$refs[this.tableRef].getDataList()
      })
    },
    reSet(){
      this.$refs[this.tableRef].reSet()
    },
    reload () {
      this.$nextTick(() => {
        if(this.$refs[this.tableRef]){
          this.$refs[this.tableRef].reload()
        }
      })
    },
    doDelete(row,labelKey){
      this.$refs[this.tableRef].doDelete(row,labelKey)
    },
    clearSelection(){
      if(this.$refs[this.tableRef]){
        this.$refs[this.tableRef].clearSelection()
      }
    },
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        if (id) {
          this.$refs.addOrUpdate.id = id
          this.$refs.addOrUpdate.dataForm.id = id
        } else {
          this.$refs.addOrUpdate.id = ''
          this.$refs.addOrUpdate.dataForm.id = ''
        }
        this.$refs.addOrUpdate.init()
      })
    },
  }
}
